import React from 'react'
import { Form } from '@deere/ux.uxframe-react';
import { containsCheckBoxAnswer, getTranslation } from '../utils/utils';

export default function CheckGroup({ section, checkSelections, handleChange, question, currentChecked,checkedproprietary }) {

    return (
        <>
            {
                checkSelections.sort((a, b) => (a.value > b.value) ? 1 : -1).map((check, index) =>
                    <Form.Check name={`${section}-${question.id}`}
                        inline id={check.id} key={check.id} label={getTranslation(check, 'text')}
                        onChange={(e) => handleChange(e, question.id)} size='sm'
                        value={check.value} checked={containsCheckBoxAnswer(check.value, currentChecked)} 
                        checkedproprietary={checkedproprietary}/>
                )
            }
        </>
    )
}